import {Fragment} from "react";

import "nouislider/dist/nouislider.css";
import "jsvectormap/dist/jsvectormap.min.css";

import '../../../public/css/lexical_1.css';
import '../../../public/css/lexical_2.css';

// import './assets/scss/Default.scss';
// import "./assets/scss/Icons.scss";

// import configureFakeBackend from "./helpers/fake-backend";
import AllRoutes from "./routes/Routes";
import AppProvidersWrapper from "./components/AppProvidersWrapper";
import React from "react";
import { ToastContainer } from "react-toastify";

import SessionManager from "./components/SessionManager";

// configureFakeBackend();

function App() {
    return (
        <Fragment>
            <AppProvidersWrapper>
                <SessionManager>
                    <AllRoutes/>
                    <ToastContainer />
                </SessionManager>
            </AppProvidersWrapper>
        </Fragment>
    )
}

export default App
